import React, { useState, useRef, useEffect } from "react";
import "./Dropdown.scss"; // basic styles

const Dropdown = ({ dropdownTrigger, dropdownMenu }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => setOpen(!open);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className="dropdown-trigger"
        tabIndex={0}
        role="button"
        onClick={toggleDropdown}
      >
        {dropdownTrigger}
      </div>

      {open && <div className="dropdown-menu">{dropdownMenu}</div>}
    </div>
  );
};

export default Dropdown;
